module.exports = __webpack_public_path__ + "static/media/ficha.ae642473.png";